// Popular currencies shown at the top of the currency selector (in order)
export const POPULAR_CURRENCY_CODES = ["usd", "idr", "bdt", "ngn", "eur", "cny", "vnd", "inr"] as const;
